module.exports = __webpack_public_path__ + "img/intro_uk.e5c3ccee.svg";